// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconArrowDown, iconArrowDownTag } from '@ni/nimble-components/dist/esm/icons/arrow-down';
import { wrap } from '../../utilities/react-wrapper';

export type { IconArrowDown };
export { iconArrowDownTag };
export const NimbleIconArrowDown = wrap(IconArrowDown);